import React, { FC, useEffect } from 'react';
import { graphql, useLazyLoadQuery } from 'react-relay/hooks';
import { printOSLoginTokenQuery } from './__generated__/printOSLoginTokenQuery.graphql';
import { CustomErrorBoundary } from './components/widgets/customErrorBoundary';
import config from './shared/config';
import { Center } from './shared/globals';
import { removeCookie, setCookie } from './shared/helpers';

const PrintOSTokenFetcher: FC<React.PropsWithChildren<{ authCode: string }>> = ({ authCode, children }) => {
    const [isCookieSet, setIsCookieSet] = React.useState(false);

    const data = useLazyLoadQuery<printOSLoginTokenQuery>(
        graphql`
            query printOSLoginTokenQuery($data: String!) {
                auth(data: $data)
            }
        `,
        { data: authCode.toString() },
        {
            fetchPolicy: 'network-only'
        }
    );

    useEffect(() => {
        if (data?.auth && !isCookieSet) {
            setCookie('zakeke_token', data.auth, 365);
            config.token = data.auth;
            setIsCookieSet(true);
        }
    }, [data, isCookieSet]);

    if (!isCookieSet) return;

    return children;
};

const PrintOSLogin: FC<React.PropsWithChildren<{}>> = ({ children }) => {
    const decodedQueryString = decodeURIComponent(window.location.search);
    const urlParams = new URLSearchParams(decodedQueryString);
    const printosAuth = urlParams.get('printos-auth');

    let content = children;

    if (printosAuth) {
        removeCookie('zakeke_token');
        content = (
            <CustomErrorBoundary render={() => <Center>Error in auth</Center>}>
                <PrintOSTokenFetcher authCode={printosAuth}>{children}</PrintOSTokenFetcher>
            </CustomErrorBoundary>
        );
    }

    return <React.Fragment>{content}</React.Fragment>;
};
export default PrintOSLogin;
